export const stylesSaveData = {
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: '#fff',
        border: '2px solid #000',
        boxShadow: '5px',
        padding: '24px 40px 32px',
        textAlign: 'center',
    },
}